import { useState } from 'react';
import { CloudDownload, Share2 } from 'lucide-react';

import { downloadFromUrl } from '@sandtech-hub-monorepo/ui-kit-site';

import { ShareBadgeModal, ShareDetails } from './ShareBadgeModal';

interface Props {
  imageUrl?: string | null;
  /** Name the PNG is saved under. */
  fileName: string;
  /** Shown in the share modal; the LinkedIn URL is the API's, as central-hub. */
  share?: ShareDetails;
}

/** Hover actions on a badge card (the parent needs `group relative`). */
export const BadgeActionsOverlay = ({ imageUrl, fileName, share }: Props) => {
  const [shareOpen, setShareOpen] = useState(false);

  return (
    <div className="absolute inset-0 hidden flex-col items-center justify-center gap-3 bg-heading/80 group-hover:flex">
      {imageUrl && (
        <button
          type="button"
          // Fetched as a blob so it always saves as a file: the `download`
          // attribute alone is ignored cross-origin and would open the image.
          onClick={() => downloadFromUrl(fileName, imageUrl)}
          aria-label="Download badge"
          className="flex h-8 w-16 items-center justify-center rounded-full bg-card text-primary"
        >
          <CloudDownload className="h-4 w-4" />
        </button>
      )}
      {share && (
        <>
          <button
            type="button"
            onClick={() => setShareOpen(true)}
            aria-label="Share badge"
            className="flex h-8 w-16 items-center justify-center rounded-full bg-primary text-primary-foreground"
          >
            <Share2 className="h-4 w-4" />
          </button>
          <ShareBadgeModal
            details={share}
            open={shareOpen}
            onOpenChange={setShareOpen}
          />
        </>
      )}
    </div>
  );
};
